var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn-toggle',{attrs:{"borderless":"","dense":"","background-color":"transparent","dark":_vm.dark,"title":_vm.$t(_vm.moduleName + '.title')},model:{value:(_vm.show),callback:function ($$v) {_vm.show=$$v},expression:"show"}},[_c('v-btn',{attrs:{"icon":"","value":true},on:{"click":_vm.toggleUi}},[_c('v-icon',{attrs:{"medium":""}},[_vm._v(_vm._s(_vm.icon))])],1)],1)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-58e1ee71","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modulecore/ToggleButton.vue
// module id = 8xuK
// module chunks = 1